var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('hero',{staticStyle:{"height":"60vh"},attrs:{"image":"https://api.ratoab.se/HeroImages?location=3","dark-background":false}}),_c('about-us',{staticClass:"mt-5"})],1)}
var staticRenderFns = []

export { render, staticRenderFns }